import Gjesteliste from './Gjesteliste';

export default Gjesteliste;